import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../atoms/Input';
import SearchIcon from '../../assets/icons/SearchIcon';
import useQueryParams from '../../hooks/useQueryParams';
import StatusFilters from './StatusFilters';
const Filters = () => {
  const { t } = useTranslation();
  const { updateQueryParam, deleteQueryParam, ValidQuery } = useQueryParams();

  return (
    <div className="flex items-center flex-col md:flex-row-reverse gap-4">
      <StatusFilters />
      <Input
        id="test"
        name="test"
        value={(ValidQuery as { searchField?: string })?.searchField || ''}
        onChange={(element) => {
          const newValue = element?.currentTarget?.value;

          if (newValue)
            updateQueryParam([
              {
                name: 'searchField',
                value: newValue,
              },
              {
                name: 'page',
                value: '0',
              },
            ]);
          else {
            deleteQueryParam(['searchField']);
          }
        }}
        prefix={<SearchIcon />}
        placeholder={t('home.searchHere')}
        className="!font-medium !h-10 mb-1"
      />
    </div>
  );
};

export default Filters;
